"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataProcessingOrNewsletterModal = DataProcessingOrNewsletterModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const CancelButton = ({ setVisible }) => ((0, jsx_runtime_1.jsx)(elements_1.Button, { type: "default", size: "middle", onClick: () => setVisible(false), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration.registration_form.cancel" }) }));
function DataProcessingOrNewsletterModal({ visible, setVisible, textId, companyName }) {
    return ((0, jsx_runtime_1.jsx)(elements_1.Modal, { visible: visible, centered: true, onCancel: () => {
            setVisible(false);
        }, footer: (0, jsx_runtime_1.jsx)(CancelButton, { setVisible: setVisible }), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: textId, values: {
                breakingLine: (0, jsx_runtime_1.jsx)("br", {}),
                companyName,
            } }) }));
}
